const VideoController = () => import('./Controller')

export default function installComponents(Vue) {
  Vue.component('VideoController', VideoController)
}
